import { PageTypes } from '@hooks/Pages/usePages'
import { CMSApiClient } from '@service/CMSApiClient'

export const mergeRegions = (
  pageRegions: Array<Object>,
  globalPageRegions: Array<Object>
) => {
  const globalPageRegionsMap = new Map()
  globalPageRegions.forEach((region: any) => {
    globalPageRegionsMap.set(region.id, region)
  })

  const mergedRegions: Array<any> = []
  pageRegions.forEach((region: any) => {
    if (
      globalPageRegionsMap.has(region.id) &&
      (!region.components || region.components.lenght == 0)
    ) {
      mergedRegions.push(globalPageRegionsMap.get(region.id))
    } else {
      mergedRegions.push(region)
    }
  })

  return mergedRegions
}

export const getRegionByID = (
  regions: Array<Object>,
  id: string
): any | null => {
  if (!regions || !id) return null
  return regions.find(({ regionId }: any) => regionId === id)
}

export const transformRegionToMap = (
  regions: Array<Object>
): Map<string, any> => {
  const regionMap = new Map()
  if (!regions) return new Map()
  regions.forEach((region: any) => {
    regionMap.set(region.id, region)
  })
  return regionMap
}

export const getCMSApiClient = (config: any, locale: string): CMSApiClient => {
  return new CMSApiClient(config, locale)
}

export const formatPageResponse = (
  rawPage: any | undefined
): PageTypes | undefined => {
  if (rawPage) {
    return {
      id: rawPage.data.content.id,
      meta: {
        title: rawPage.data.title,
        description: rawPage.data.description,
        keywords: rawPage.data.keywords,
        canonicals: rawPage.data.canonicals
      },
      found: true,
      content: rawPage.data.content
    }
  }

  return undefined
}
